export default __webpack_public_path__ + "static/media/photo--lg--kara4.8cc3d82e.jpg";